import { ApiClient } from "@/services/apiClient/ApiClient";
import type { CategoryId } from "@/services/collection/categories/categoriesSchema";
import type { FilledInParameter, FilledInParameterId } from "./parametersSchema";
import { FilledInParameter_Schema, ItemParameter_Schema, type ItemParameter, type ParameterElasticId } from "./parametersSchema";
import type { CollectionItemId } from "@/services/collection/item/collectionItemTypes";
import { z } from "zod";
import type { AxiosResponse } from "axios";

const FetchParametersForCategoryResponse_Schema = z.object({ parameters: ItemParameter_Schema.array() });

export const fetchParametersForCategory = async (categoryId: CategoryId): Promise<ItemParameter[]> => {
  const url = "api-public/collection/item-parameter";
  return ApiClient.getPublic<unknown>(url, { categoryId }, undefined, 120_000).then(({ data }) => FetchParametersForCategoryResponse_Schema.parse(data).parameters);
};

export type ParameterSetRequest = { keyId: ParameterElasticId; customValue: string } | { keyId: ParameterElasticId; valueId: number };

export const batchSetCollectionItemParameters = async (collectionItemId: CollectionItemId, parameters: ParameterSetRequest[]): Promise<void> => {
  const url = "api/collection/collection-item-meta";
  await ApiClient.put(url, {}, { collectionItemId, parameters });
};

export const setCollectionItemParameter = async (collectionItemId: CollectionItemId, parameter: ParameterSetRequest): Promise<FilledInParameter> => {
  const url = "api/collection/collection-item-meta";
  return ApiClient.post<FilledInParameter>(url, {}, { collectionItemId, ...parameter }).then(({ data }) => FilledInParameter_Schema.parse(data));
};

export const deleteCollectionItemParameter = async (relationId: FilledInParameterId): Promise<AxiosResponse> => {
  const url = "api/collection/collection-item-meta/" + relationId;
  return ApiClient.delete(url);
};
